import { withInstall } from '@zoryn/utils'
import Transfer from './src/transfer.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTransfer: SFCWithInstall<typeof Transfer> = withInstall(Transfer)
export default ZTransfer

export * from './src/transfer'
